@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

@if (attributes.mode === 'stage' || attributes.mode === undefined) {
  <div class="stage">
    <kb-icon [icon]="iconBrakeshoeLeft"></kb-icon>
    @if (attributes.visuals.length === 1) {
      <app-visual-overlayed-figure class="stage-content" [section]="attributes.visuals[0]" [rootColumns]="attributes.numColumns === 12 ? 8 : 6"/>
    } @else {
      <kb-gallery class="stage-content">
        @for (visual of attributes.visuals; track visual) {
          <app-visual-overlayed-figure kbGalleryPage [section]="visual" [rootColumns]="attributes.numColumns === 12 ? 8 : 6"/>
        }
      </kb-gallery>
    }
    <kb-icon [icon]="iconBrakeshoeRight"></kb-icon>
  </div>
} @else if (attributes.mode === 'normal') {
  @if (attributes.visuals.length === 1) {
    <app-visual-figure [section]="attributes.visuals[0]" [rootColumns]="attributes.numColumns"/>
  } @else {
    <kb-gallery>
      @for (visual of attributes.visuals; track visual) {
        <app-visual-figure kbGalleryPage [section]="visual" [rootColumns]="attributes.numColumns"/>
      }
    </kb-gallery>
  }
} @else if (attributes.mode === 'overlay') {
  @if (attributes.visuals.length === 1) {
    <app-visual-overlayed-figure [section]="attributes.visuals[0]" [rootColumns]="attributes.numColumns"/>
  } @else {
    <kb-gallery>
      @for (visual of attributes.visuals; track visual) {
        <app-visual-overlayed-figure kbGalleryPage [section]="visual" [rootColumns]="attributes.numColumns"/>
      }
    </kb-gallery>
  }
}

@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
